var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14 12.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,0C3.1,0,0,2.6,0,5.7c0,1.4,0.6,2.6,1.6,3.6c-0.4,1.4-1.5,2.6-1.5,2.6C0,11.9,0,12.1,0,12.1 c0.1,0.1,0.1,0.1,0.2,0.1c1.8,0,3.2-0.8,3.8-1.4c0.9,0.3,1.9,0.5,3,0.5c3.9,0,7-2.5,7-5.7C14,2.6,10.9,0,7,0z M10.1,5.9 c0,0.2-0.2,0.4-0.4,0.4h-2v2c0,0.2-0.2,0.4-0.4,0.4H6.8c-0.2,0-0.4-0.2-0.4-0.4v-2h-2C4.2,6.3,4,6.1,4,5.9V5.5C4,5.2,4.1,5,4.4,5h2 V3c0-0.2,0.2-0.4,0.4-0.4h0.4c0.2,0,0.4,0.2,0.4,0.4v2h2c0.2,0,0.5,0.1,0.5,0.4V5.9L10.1,5.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/Add-Comment.baa1b41e84abdb9eda8c8dda0e0d2ac7.svg";
export { ForwardRef as ReactComponent };